import styled from 'styled-components';
import { FiSquare, FiCheckSquare } from 'react-icons/fi';
import { Paragraph } from 'components/ui/Typography';
import { spacing2x } from 'theme/spacings';
import { blue, greyDarkest, black } from 'theme/colors';

export const SquareIcon = styled(FiSquare)`
	color: ${greyDarkest};
	margin-top: 0.1rem;
	position: absolute;
	left: 0;
`;
export const SquareCheckIcon = styled(FiCheckSquare)`
	display: none;
	color: ${blue};
	margin-top: 0.1rem;
	position: absolute;
	left: 0;
`;

export const Fieldset = styled.fieldset`
	border: 0;
	padding: 0;
`;

export const DefaultCheckbox = styled.input`
	opacity: 0;
	position: relative;

	:checked + ${SquareIcon} {
		display: none;
	}

	:checked ~ ${SquareCheckIcon} {
		display: inline-block;
	}
`;

export const Body = styled(Paragraph)`
	width: 100%;
	display: inline-flex;
	justify-content: space-between;
	margin: 0 0 0 ${spacing2x};
`;

export const RightContent = styled.span`
	color: ${greyDarkest};
`;

export const LeftContent = styled.span`
	color: ${black};
`;
